"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headers = exports.createBcfApi = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const headers = exports.headers = {
  "Content-Type": "application/json"
};
const bcfOrigin = (() => {
  const env = (0, _acsScWebPlatformApi.getEnv)();
  switch (env) {
    case _acsScWebPlatformApi.ENVS.PRODUCTION:
      return "https://developer.api.autodesk.com/construction/bcf/v1";
    case _acsScWebPlatformApi.ENVS.STAGING:
      return "https://developer-stg.api.autodesk.com/construction/bcf/v1";
    case _acsScWebPlatformApi.ENVS.QA:
      return "https://developer-stg.api.autodesk.com/construction/bcf-qa/v1";
    default:
      throw new Error("Using bcfUrl outside of supported envs");
  }
})();
const createBcfApi = exports.createBcfApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    prepareImport() {
      let bcfTopicIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return api.create("bcf/import", {
        bcfTopicIds
      }).then(response => {
        return response;
      });
    },
    startImport(attributes, id) {
      return api.create("bcf/import/".concat(id), attributes).then(response => response);
    },
    pollImportStatus(id) {
      return api.get("bcf/import/".concat(id), {
        staleTime: 0 // polling should fetch fresh data only
      });
    }
  };
}, {
  origin: bcfOrigin,
  invalidateByQueryKeys: () =>
  // BCF import creates many Issues
  _queryClientUtils.INVALIDATE_ALL_ISSUES
});
//# sourceMappingURL=BcfApi.js.map